"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldActionButton = exports.CSS = void 0;
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const icon_1 = require("../icon");
const icons_1 = require("../icon/icons");
const theme_1 = require("../theme");
const photomeasure_svg_1 = require("./photomeasure.svg");
exports.CSS = {
    container: 'c-FieldActionBtn',
    isLinkable: 'c-FieldActionBtn--linkable',
    isLinking: 'c-FieldActionBtn--linking',
    joinable: 'c-FieldActionBtn--joinable',
    linkContainer: 'c-FieldActionBtn__Link',
    photoMeasureIcon: 'c-FieldActionBtn__PhotoMeasure',
    errorIcon: 'c-FieldActionBtn__error'
};
const Style = {
    [exports.CSS.container]: {
        display: 'flex',
        'justify-content': 'flex-end',
        width: '100%'
    },
    [exports.CSS.isLinkable + ' button']: {
        color: theme_1.DefaultTheme.font.color.white,
        'background-color': theme_1.DefaultTheme.color.accent
    },
    [exports.CSS.joinable]: {
        'background-image': photomeasure_svg_1.PHOTO_MEASURE_SVG_URL,
        'background-repeat': 'no-repeat',
        'background-size': '18px',
        width: '20px',
        height: '20px',
        'background-position': 'center',
        '&[disabled]': {
            'background-image': photomeasure_svg_1.PHOTO_MEASURE_SVG_URL_DISABLED
        }
    },
    [exports.CSS.linkContainer]: {
        'font-size': '12px',
        'background-color': theme_1.DefaultTheme.font.color.supporting,
        border: 'none',
        outline: 'none',
        color: theme_1.DefaultTheme.font.color.white,
        padding: '0 ' + theme_1.DefaultTheme.space(2),
        'align-items': 'center',
        'border-radius': theme_1.DefaultTheme.space(4),
        'font-weight': 'bold',
        display: 'flex',
        cursor: 'pointer',
        '& i': {
            'font-size': '20px',
            'margin-left': theme_1.DefaultTheme.space(1)
        },
        width: '100%',
        'justify-content': 'center'
    },
    [exports.CSS.photoMeasureIcon]: {
        transform: ' rotate(-90deg) !important'
    },
    [exports.CSS.errorIcon]: {
        color: theme_1.DefaultTheme.font.color.error,
        cursor: 'default'
    }
};
(0, theme_1.addStyles)(Style);
exports.FieldActionButton = {
    view(cfg) {
        const icon = cfg.linking ? icons_1.MaterialIcon.CLOSE : cfg.icon;
        const text = cfg.linking ? cfg.linkingText : cfg.text;
        const title = cfg.title;
        return (0, mithril_1.m)('div', { className: `${exports.CSS.container} ${cfg.linking ? exports.CSS.isLinking : exports.CSS.isLinkable}` }, [
            (0, mithril_1.m)('button', { className: exports.CSS.linkContainer, onclick: cfg.onclick, title: (0, index_1.Translate)(title) }, [
                (0, index_1.Translate)(text),
                icon_1.Icon.view(icon, { type: 'button' })
            ])
        ]);
    },
    viewLinkHeight(cfg) {
        let icon;
        if (cfg.joinable) {
            icon = icon_1.Icon.view(icons_1.MaterialIcon.NONE, { type: 'button', className: `${exports.CSS.photoMeasureIcon} ${exports.CSS.joinable}` });
        }
        else if (cfg.linking) {
            icon = icon_1.Icon.view(icons_1.MaterialIcon.CLOSE, { type: 'button' });
        }
        else {
            icon = icon_1.Icon.view(icons_1.MaterialIcon.PHOTO_MEASURE, { type: 'button', className: exports.CSS.photoMeasureIcon });
        }
        const text = cfg.linking ? index_1.T.PHOTOMEASURE_LINK : index_1.T.PHOTOMEASURE_LINK_START;
        const title = cfg.joinable ? index_1.T.PHOTOMEASURE_JOIN : index_1.T.PHOTOMEASURE_LINK_START;
        return (0, mithril_1.m)('div', { className: `${exports.CSS.container} ${cfg.linking ? exports.CSS.isLinking : exports.CSS.isLinkable}` }, [
            (0, mithril_1.m)('button', { className: exports.CSS.linkContainer, onclick: cfg.onclick, title: (0, index_1.Translate)(title) }, [
                (0, index_1.Translate)(text),
                icon
            ])
        ]);
    },
    viewLinkVerticalSeparation(cfg) {
        let icon;
        let text;
        let className = `${exports.CSS.container} ${cfg.linking ? exports.CSS.isLinking : exports.CSS.isLinkable}`;
        let title;
        var errorIcon = icon_1.Icon.view(icons_1.MaterialIcon.WARNING, { type: 'button', className: `${exports.CSS.errorIcon}` });
        if (cfg.joinable) {
            icon = icon_1.Icon.view(icons_1.MaterialIcon.NONE, { type: 'button', className: `${exports.CSS.photoMeasureIcon} ${exports.CSS.joinable}` });
            text = title = (0, index_1.Translate)(index_1.T.VERTICAL_SEPARATION_TOP);
        }
        else if (cfg.linking) {
            icon = icon_1.Icon.view(icons_1.MaterialIcon.CLOSE, { type: 'button' });
            text = title = (0, index_1.Translate)(index_1.T.PHOTOMEASURE_LINK);
        }
        else {
            icon = icon_1.Icon.view(icons_1.MaterialIcon.PHOTO_MEASURE, { type: 'button', className: exports.CSS.photoMeasureIcon });
            text = title = (0, index_1.Translate)(index_1.T.VERTICAL_SEPARATION_TOP);
            if (cfg.hasTop && !cfg.hasBottom) {
                text = title = (0, index_1.Translate)(index_1.T.VERTICAL_SEPARATION_BOTTOM);
            }
        }
        var resultDiv = [];
        if (cfg.hasError) {
            resultDiv.push(errorIcon);
            title = (0, index_1.Translate)(index_1.T.VERTICAL_SEPARATION_INVALID);
        }
        resultDiv.push((0, mithril_1.m)('button', { className: exports.CSS.linkContainer, onclick: cfg.onclick }, [
            text,
            icon
        ]));
        return (0, mithril_1.m)('div', { className, title }, resultDiv);
    }
};
//# sourceMappingURL=field.action.button.js.map